const switchSliderTokens = ({ colors, space }) => ({
  colors: {
    bg: colors.neutrals[5],
    borderColor: colors.neutrals[4],
    checkedBg: colors.brandPrimary[1],
    checkedBorderColor: 'transparent',
    activeBg: colors.neutrals[5],
  },
  space: {
    left: `${space[1]}px`,
    checkedLeft: `${space[1]}px`,
  },
  sizes: {
    medium: {
      width: 'auto',
      height: 'auto',
      bubbleSize: `${space[5]}px`,
    },
  },
});

export default switchSliderTokens;
